import React from "react";

import "./ImagesGrid.scss";
import { IconButton } from "@material-ui/core";
import { RiDeleteBin7Line } from "react-icons/ri";

const ImagesGrid = (props) => {
  const removing = { value: false, id: "" };

  return (
    <div className="image-grid">
      {props.images &&
        props.images.map((image) => {
          return (
            <div key={image} className="image-container">
              <img src={image} alt="variant image" />

              {props.name !== "view" && (
                <IconButton
                  disabled={removing.value}
                  onClick={() => {
                    props.remove(
                      props.images.filter((url) => url !== image),
                      image,
                    );
                  }}
                  className="remove-button"
                  size="small"
                >
                  <RiDeleteBin7Line size="1.5rem" />
                </IconButton>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default ImagesGrid;
